function readSelectValue(form, selector) {
  const el = form.querySelector(selector);
  if (!el || el.value === '0' || el.value === '') {
    return null;
  }
  return el.value;
}

function readInputValue(form, selector) {
  const el = form.querySelector(selector);
  if (!el || el.value === '') {
    return null;
  }
  return el.value;
}

function collectFiltersFromForm(form) {
  const filters = [];

  form.querySelectorAll('.form-group').forEach((group) => {
    const filterEl = group.querySelector('.filter-select');
    const operatorEl = group.querySelector('.operator-select');
    const valueEl = group.querySelector('.value-input');

    if (!filterEl || !operatorEl || !valueEl) {
      return;
    }

    if (
      filterEl.value === '0' ||
      operatorEl.value === '0' ||
      valueEl.value === ''
    ) {
      return;
    }

    filters.push({
      filter: filterEl.value,
      operator: operatorEl.value,
      value: Number(valueEl.value),
    });
  });

  return filters;
}

function collectDataFieldsFromForm(form) {
  const dataFields = [];

  form.querySelectorAll('.form-group').forEach((group) => {
    const typeEl = group.querySelector('.type-select');
    const fieldEl = group.querySelector('.field-select');

    if (!typeEl || !fieldEl) {
      return;
    }

    if (typeEl.value === '0' || fieldEl.value === '0') {
      return;
    }

    dataFields.push({
      type: typeEl.value,
      field: fieldEl.value,
    });
  });

  return dataFields;
}

export function buildExportQueryParamsFromForm(form) {
  const params = {};

  const template = readSelectValue(form, '#template');
  if (template) {
    params.template = template;
  }

  const deviceId = readInputValue(form, '#device-id');
  if (deviceId) {
    params.deviceId = deviceId;
  }

  const interval = readSelectValue(form, '#interval');
  if (interval) {
    params.interval = interval;
  }

  const aggregation = readSelectValue(form, '#aggregation');
  if (aggregation) {
    params.aggregation = aggregation;
  }

  const deviceGroup = readSelectValue(form, '#deviceGroups');
  if (deviceGroup) {
    params.deviceGroup = deviceGroup;
  }

  const startDate = readInputValue(form, '#start-date');
  const endDate = readInputValue(form, '#end-date');
  if (startDate) {
    params.startDate = startDate;
  }
  if (endDate) {
    params.endDate = endDate;
  }

  const category = readSelectValue(form, '#category');
  if (category) {
    params.category = category;
  }

  const scaleType = readSelectValue(form, '.scale-select');
  if (scaleType) {
    params.scaleType = scaleType;
  }

  const scaleValue = readInputValue(form, '.scale-input');
  if (scaleValue != null) {
    params.scaleValue = scaleValue;
  }

  const alias = readInputValue(form, '.alias-input');
  if (alias) {
    params.alias = alias;
  }

  const filters = collectFiltersFromForm(form);
  if (filters.length > 0) {
    params.filters = filters;
  }

  const dataFields = collectDataFieldsFromForm(form);
  if (dataFields.length > 0) {
    params.dataFields = dataFields;
  }

  return params;
}
